import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Spinner from './Spinner';
import userIcon from '../assets/icons/account.png';
import imageIcon from '../assets/icons/image-icon.png';
import close from '../assets/icons/close-white.png';
import sendIcon from '../assets/icons/send-icon.png';
import deleteIcon from '../assets/icons/trash-icon.png';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';

export default function Comments(props) {
    const { 
        id,
        user
    } = props;

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [comments, setComments] = useState([]);
    const [newComment, setNewComment] = useState('');
    const [image, setImage] = useState(null);

    const getComments = () => {
        setLoading(true);
        axios.get(`https://firewatch-api.space-eyes.com/fires/${id}/comments`)
        .then((res) => {
            setLoading(false);
            setComments(res.data.comments);
        }).catch((err) => {
            setLoading(false);
            console.log('error getting comments: ', err);
        });
    }

    useEffect(() => {
        getComments();
    }, []);

    const addComment = () => {
        setLoading(true);
        setError(false);
        if (typeof newComment === 'string' && newComment.trim().length > 0) {
            if (image) {
                axios.post(`https://firewatch-api.space-eyes.com/fires/${id}/comments`, {
                    content: newComment
                }, 
                {
                    headers: {
                        'Authorization': `Bearer ${user.idToken.jwtToken}`
                    }
                }
                ).then((response) => {
                    axios.get(`https://firewatch-api.space-eyes.com/fires/${id}/comments/presign-media?comment_id=${response.data.comment_id}&file_name=${image.name}`, {
                        headers: {
                            'Authorization': `Bearer ${user.idToken.jwtToken}`
                        }
                    })
                    .then((res) => {
                        const formData = new FormData();
                        Object.entries(res.data.presigned_s3_url.fields).forEach(([key, value]) => {
                            formData.append(key, value);
                        });
                        formData.append('file', image);

                        axios.post(res.data.presigned_s3_url.url, formData)
                        .then(() => {
                            const imageURL = `${res.data.presigned_s3_url.url}${res.data.presigned_s3_url.fields.key}`;
                            axios.put(`https://firewatch-api.space-eyes.com/fires/${id}/comments?comment_id=${response.data.comment.comment_id}&media=${imageURL}`, 
                                null,
                                {
                                    headers: {
                                        'Authorization': `Bearer ${user.idToken.jwtToken}`
                                    }
                                })
                            .then((r) => {
                                console.log(r.data.comment);
                                setComments([...comments, r.data.comment]);
                                setLoading(false);
                                setNewComment('');
                                setImage(null);
                            }).catch((err) => {
                                console.log('error putting comment', err.response.data);
                            }
                            );
                        }).catch((err) => {
                            console.log('error posting comment (no image)', err);
                            setLoading(false);
                            setError('Trouble adding comment. Please try again.');
                        }
                        );
                    }).catch((err) => {
                        console.log('error getting comment', err);
                        setError('Trouble adding comment. Please try again.');
                        setLoading(false);
                    }
                    );
                }).catch((err) => {
                    console.log('error posting comment', err);
                    setError('Trouble adding comment. Please try again.');
                    setLoading(false);
                }
                );
            } else {
                axios.post(`https://firewatch-api.space-eyes.com/fires/${id}/comments`, {
                    content: newComment
                }, 
                {
                    headers: {
                        'Authorization': `Bearer ${user.idToken.jwtToken}`
                    }
                }
                ).then((response) => {
                    console.log('comment added succesfully');
                    setLoading(false);
                    setNewComment('');
                    setComments([...comments, response.data.comment])
                }).catch((err) => {
                    console.log('error adding comment', err);
                    setError('Trouble adding comment. Please try again.');
                    setLoading(false);
                }
                );
            }
        } else {
            setLoading(false);
            console.log('invalid comment');
            setError('All comments require text.');
        }
    }

    const deleteComment = (commentId) => {
        setLoading(true);
        axios.delete(`https://firewatch-api.space-eyes.com/fires/${id}/comments?comment_id=${commentId}`, {
            headers: {
                'Authorization': `Bearer ${user.idToken.jwtToken}`
            }
        }
        ).then((res) => {
            console.log('comment deleted succesfully');
            setComments(comments.filter((comment) => comment.comment_id !== commentId));
            setLoading(false);
        }).catch((err) => {
            console.log('error deleting comment', err);
            setLoading(false);
        });
    }
       
    const timeSince = (timestampStr) => {
        if (typeof timestampStr !== 'string') {
            return '';
        }
    
        const formattedTimestamp = timestampStr.replace(' ', 'T') + 'Z';
        const date = new Date(formattedTimestamp);
    
        if (isNaN(date.getTime())) {
            return 'Invalid date';
        }

        date.setHours(date.getHours());
    
        const now = Date.now();
        const timeDiff = now - date.getTime();
    
        if (timeDiff < 0) {
            return '';
        }
    
        const seconds = Math.floor(timeDiff / 1000);
        if (seconds < 60) {
            return `${seconds}s`;
        }
    
        const minutes = Math.floor(seconds / 60);
        if (minutes < 60) {
            return `${minutes}m`;
        }
    
        const hours = Math.floor(minutes / 60);
        if (hours < 24) {
            return `${hours}h`;
        }
    
        const days = Math.floor(hours / 24);
        if (days < 30) {
            return `${days}d`;
        }
    
        const months = Math.floor(days / 30);
        if (months < 12) {
            return `${months}mo`;
        }
    
        const years = Math.floor(months / 12);
        return `${years}y`;
    }

    return (
        <div className='map-controls-settings-window-activeFire-comments'>
        {
            loading ? 
            <>
                <Spinner />
                <br></br>
            </>
            : <div className='map-controls-settings-window-activeFire-comments-list'>
                {
                    comments.length > 0 ?
                        comments.map((comment) => {
                            if(comment.cognito_user_id === user.idToken.payload.sub) {
                                return <div className='map-controls-settings-window-activeFire-comments-comment'>
                                    <div className='map-controls-settings-window-activeFire-comments-comment-name'>
                                        You
                                    </div>
                                    {
                                        comment.media &&
                                        <PhotoProvider>
                                            <PhotoView src={comment.media} >
                                                <img src={comment.media} className='map-controls-settings-window-activeFire-comments-comment-image'/>
                                            </PhotoView>
                                        </PhotoProvider>
                                    }
                                    <div className='map-controls-settings-window-activeFire-comments-comment-bubble'>
                                        {comment.content}
                                    </div>
                                    <div className='map-controls-settings-window-activeFire-comments-comment-time'>
                                        {timeSince(comment.created_timestamp)}
                                    </div>
                                    <img src={deleteIcon} className='map-controls-settings-window-activeFire-comments-comment-trash' onClick={() => deleteComment(comment.comment_id)}/>
                                </div>
                            }
                            else
                                return <div className='map-controls-settings-window-activeFire-comments-comment'>
                                    <div className='map-controls-settings-window-activeFire-comments-comment-name-alt'>
                                        {comment.full_name}
                                    </div>
                                    {
                                        comment.media &&
                                        <PhotoProvider>
                                            <PhotoView src={comment.media} >
                                                <img src={comment.media} className='map-controls-settings-window-activeFire-comments-comment-image-alt'/>
                                            </PhotoView>
                                        </PhotoProvider>
                        
                                    }
                                    <div className='map-controls-settings-window-activeFire-comments-comment-bubble-alt'>
                                        {comment.content}
                                    </div>
                                    <div className='map-controls-settings-window-activeFire-comments-comment-time-alt'>
                                        {timeSince(comment.created_timestamp)}
                                    </div>
                                </div>
                        })
                    :
                    <div className='map-controls-settings-window-activeFire-comments-list-empty'>Be the first to comment!</div>
                }
            </div>
        }
        {error && 
        <>
            <div className='map-panel-error-text'>{error}</div>
            <br></br>
        </>}
            <div className='map-controls-settings-window-activeFire-comments-post'>
                <img src={userIcon} className='map-controls-settings-window-activeFire-comments-post-icon'/>
                <input value={newComment} placeholder='Join the conversation...' className='map-controls-settings-window-activeFire-comments-post-input' onChange={(e) => setNewComment(e.target.value)} disabled={loading}/>
                    <div className='map-controls-settings-window-activeFire-comments-post-button-image-close-container'>
                        <img src={imageIcon} className='map-controls-settings-window-activeFire-comments-post-button-image-close-image'/>
                        {image && <img src={close} className='map-controls-settings-window-activeFire-comments-post-button-image-close' onClick={() => setImage(null)}/>}
                        {!image && 
                        <input
                            type="file"
                            id="file-input"
                            className="map-controls-settings-window-activeFire-comments-post-button-file"
                            onChange={(e) => setImage(e.target.files[0])}
                        />}
                    </div>
                <img src={sendIcon} className='map-controls-settings-window-activeFire-comments-post-button' onClick={addComment}/>
            </div>
        </div>
    )
}